export default () => {
    document.addEventListener('DOMContentLoaded', function () {
        const sections = document.querySelectorAll('section[id]')
        let menuBtn = document.querySelector('.menu-btn');
        let menu = document.querySelector('.promo-menu');
        let menuCross = document.querySelector('.promo-menu__cross');

        const menuItems = document.querySelectorAll('.promo-item')
        const orderBtn = document.querySelector('.promo-menu__btn')

        window.addEventListener('scroll', autoHighlight)

        menuBtn.addEventListener('click', function () {
            menu.classList.toggle('active');
        });

        menuCross.addEventListener('click', function () {
            menu.classList.remove('active');
        });

        menuItems.forEach(menuItem => {
            menuItem.addEventListener('click', function () {
                // menuItems.forEach(item => item.classList.remove('active'))
                // menuItem.classList.add('active')
                menu.classList.remove('active');
            })

        })

        orderBtn.addEventListener('click', function () {
            menu.classList.remove('active');
        });

        function autoHighlight() {
          sections.forEach(section => {
            var topOffset = section.offsetTop - 100,
                bottomPosition = topOffset + section.clientHeight,
                scrollPosition = window.scrollY,
                elId = section.getAttribute('id');

            if (scrollPosition > topOffset && scrollPosition < bottomPosition) {
              menuItems.forEach(item => {
                item.classList.remove('active')
              });
              [...menuItems].find(btn => btn.href.split('#')[1] === elId).classList.add('active')
            }
          })
        }

        function setMenuPosition() {
            const container = document.querySelector('.container')
            const menuWind = document.querySelector('.promo-menu')

            window.addEventListener('resize', setLeftPosition)

            function setLeftPosition() {
                const winWidth = window.innerWidth

                if (winWidth > 1024) {
                    menuWind.style.left = `${(winWidth - container.clientWidth) / 2}px`
                } else {
                    menuWind.style.left = 'auto'
                }
            }
            setLeftPosition()
        }
        setMenuPosition()
    });

};
